import { useCallback } from 'react'
import { useAction } from '@shared/lib/redux'

import { navbarStore } from './navbar.slice'

export const useNavbarCollapse = () => {
  const toggle = useAction(navbarStore.actions.setPannelCollapsed)

  return {
    navbarOpen: useCallback(() => toggle(false), [toggle]),
    navbarClose: useCallback(() => toggle(true), [toggle])
  }
}
